// extracted by mini-css-extract-plugin
export default {"dashboard":"styles_dashboard__vaXb0"};